import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

const PAGE_META = {
  "/": {
    title: "DROSUN ITALIA — Progettazione e Produzione di Prodotti in Plastica, Metallo e Stampi",
    description: "Drosun Italia: progettazione, sviluppo stampi, produzione e assemblaggio industriale di prodotti in plastica e metallo.",
  },
  "/servizi": {
    title: "Servizi di Progettazione, Produzione e Assemblaggio Industriale | DROSUN ITALIA",
    description: "Stampaggio plastica, lavorazioni CNC, produzione componenti, assemblaggio industriale e soluzioni OEM/ODM.",
  },
  "/prodotti/componenti-arredamento": {
    title: "Componenti e Prodotti per Arredamento | Drosun Italia",
    description: "Drosun Italia progetta e realizza componenti tecnici, prodotti completi e accessori per il settore arredamento, interior design e infissi con produzione industriale su misura.",
  },
  "/prodotti/componenti-nautica": {
    title: "Componenti e Sistemi per la Nautica | Drosun Italia",
    description: "Drosun Italia progetta e realizza componenti tecnici, sistemi e prodotti completi per il settore navale e della nautica da diporto con produzione industriale conto terzi.",
  },
  "/prodotti/packaging-cosmetico": {
    title: "Packaging Cosmetico Personalizzato | Drosun Italia",
    description: "Drosun Italia progetta e realizza packaging cosmetico personalizzato, componenti tecnici e sistemi completi per il settore beauty e profumeria con produzione industriale conto terzi.",
  },
  "/prodotti/food-packaging-pet": {
    title: "Packaging Alimentare PET | Vaschette Termoformate | Drosun Italia",
    description: "Drosun Italia progetta e produce packaging alimentare in PET, vaschette termoformate e contenitori per GDO e Food Service con produzione industriale conto terzi.",
  },
  "/contatti": {
    title: "Contatti | DROSUN ITALIA",
    description: "Contatta Drosun Italia per engineering, produzione industriale, componenti tecnici e packaging conto terzi.",
  },
  "/privacy": { title: "Privacy Policy | DROSUN ITALIA", description: "Informativa sulla privacy del sito Drosun Italia." },
  "/cookie": { title: "Cookie Policy | DROSUN ITALIA", description: "Informativa sui cookie del sito Drosun Italia." },
};

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META["/"];
    document.title = meta.title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", meta.description);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 pt-[96px] lg:pt-[104px]"><Outlet /></main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
